import { useEffect } from 'react';
import { useAppUpdatesContext } from '@app/app/src/AppContext';
import { useUserContext } from './UserProvider';

/**
 * Hook that handles authentication on app load.
 * Reads the user from UserContext (fetched once by UserProvider) and dispatches
 * AUTHENTICATE to set the user in AppUpdatesContext if not already set.
 * Should be called once at the app root level.
 */
export const useAuth = () => {
  const { state, dispatch } = useAppUpdatesContext();
  const { user } = useUserContext();

  useEffect(() => {
    // User is pre-seeded into AppUpdatesContext via initialState in App.tsx,
    // but dispatch here as a safety net in case it wasn't available at init time.
    if (state.user || !user) return;

    dispatch({ type: 'AUTHENTICATE', payload: { user } });
  }, [user, state.user, dispatch]);
};
